App.namespace.wrap('es6.views.quick_estimate.form_data_keeper', () => {
  const tempStorageManager = App.es6.shared.temporary_storage_manager({
    type: 'local',
    expire: 14 * 24 * 60 * 60, // 14 days
    key: 'room-sidebar-form-v3',
  });

  let isFrozen = false;
  const freeze = () => {
    isFrozen = true;
  }

  const getDataToSave = (data) => {
    const dataToSave = {};
    const keysToSave = [
      'room_tag',
      'room_tag_autocomplete',
      'enquiry_flexible_on_time',
      'own_catering',
      'require_catering',
      'enquiry_catering_options_breakfast',
      'enquiry_catering_options_tea_and_coffee',
      'enquiry_catering_options_lunch',
      'enquiry_catering_options_dinner',
      'enquiry_catering_options_drinks_reception',
      'enquiry_catering_options_open_bar',
      'enquiry_catering_options_other',
      'enquiry_catering_options_seated_meal',
      'enquiry_catering_options_buffet',
      'enquiry_catering_options_canapes',
      'enquiry_fullname',
      'date',
      'people',
      'layout',
      'time_from',
      'time_to',
      'enquiry_comment',
      'enquiry_fullname',
      'enquiry_email',
      'enquiry_phone',

      // for RtB flow
      'analytics_client_id',
      'referrer',
      'event_offer_name',
      'source',
    ];

    keysToSave.forEach(key => {
      if (data[key]) {
        dataToSave[key] = data[key];
      }
    });

    return dataToSave;
  }

  const get = () => {
    return tempStorageManager.get();
  };

  const setRawData = (data) => {
    if (isFrozen) {
      return;
    }

    if (data.freeze) {
      freeze();
    }

    tempStorageManager.set(getDataToSave(data));
  };

  const mergeData = (data) => {
    if (isFrozen) {
      return;
    }

    if (data.freeze) {
      freeze();
    }

    const currentData = get();
    const mergedData = {
      ...currentData,
      ...getDataToSave(data),
    };

    tempStorageManager.set(mergedData);
  }

  return {
    get,
    setRawData,
    mergeData,
  };
});
